import {Injectable} from '@angular/core';
import {Subject} from "rxjs";
import {OfficialTeam, TeamStatus} from "../model/resources/team";
import {DialogService} from "./dialog.service";

@Injectable({
  providedIn: 'root'
})
export class TeamService {
  execChange: Subject<OfficialTeam> = new Subject<OfficialTeam>();
  team: OfficialTeam | null = null;

  constructor(
    private dialogService: DialogService,
  ) { }

  getTeam(): OfficialTeam | null {
    return this.team;
  }

  // subscribeしているコンポーネントに情報を反映させる
  setTeam(team: OfficialTeam): void {
    this.team = team;
    this.execChange.next(team);
  }

  async checkActiveStatus(): Promise<boolean> {
    const teamStatus = this.team?.status;
    let errMsg: string | null = null;

    if (teamStatus === TeamStatus.suspended) {
      errMsg = 'このチームは活動休止中のため操作を行えません。\n活動再開をご希望の場合、営業担当までお問い合わせください。'
    } else if (teamStatus === TeamStatus.disbanded) {
      errMsg = 'このチームは解散済みのため操作を行えません。';
    } else if (teamStatus === TeamStatus.draft) {
      errMsg = 'このチームは下書き（非公開）状態のため操作を行えません。「チーム管理」画面にて公開設定が完了した後に操作が行えるようになります。';
    }

    if (errMsg === null) {
      return true;
    } else {
      await this.dialogService.alert({title: 'エラー', content: errMsg});
      return false;
    }
  }
}
